/*
  File name: index.js
    Program Description:
    - This file sets the state values for the pbnef state.
*/
import { getField, updateField } from 'vuex-map-fields'
const getDefaultState = () => {
  return {
    dbnNumber: '',
    docketNumber: '',
    isSubmitted: true,
    status: '',
    nameOfPic: '',
    requestFor: [],
    specify: '',
    dataSubjects: [],
    specifyIfOthers: '',
    specifyIfGroup: '',
    numberOfDataSubjectsAffected: '',
    atLeastOneHundredIndividuals: false,
    natureOfPersonalDataInvolved: {
      remarks: '',
      checklist: [],
      additionalChecklist: []
    },
    measuresInPlace: {
      remarks: '',
      checklist: []
    },
    explanation: '',
    evaluation: '',
    evaluatedBy: '',
    initialReviewedBy: '',
    finalReviewBy: '',
    approvedBy: '',
    approveReject: '',
    endorsedTo: '',
    forAdjudication: false,
    fileUpload: [],
    $meta: {
      loading: false,
      readOnly: true,
      routes: {
        dbn: 'pdbnf',
        pbnef: 'pbnef',
        create: 'pbnef',
        update: 'pbnef'
      }
    },
    dbnStatus: [],
    pbnefList: [],
    typeOfRequests: [],
    users: [],
    numberOfDrafts: 0,
    assignedTo: null,
    isAssignee: false,
    statusObject: {},
    statusHistory: [],
    typeOfRequestOther: '',
    pdbnfRequest: [],
    isStageValid: false,
    submittedPBNEF: [],
    _status: '',
    justification: {}
  }
}

const state = getDefaultState()

const mutations = {
  updateField,
  set (state, payload) {
    for (const key in payload) {
      Object.prototype.hasOwnProperty.call(state, key) && (state[`${key}`] = payload[`${key}`])
    }
  },
  reset (state) {
    Object.assign(state, getDefaultState())
  },
  setMeta (state, payload) {
    for (const key of Object.keys(payload)) {
      state.$meta[`${key}`] = payload[`${key}`]
    }
  }
}

const getters = {
  getField
}

const actions = {
  async set ({ commit }, payload) {
    commit('set', payload)
  },
  async reset ({ commit }) {
    commit('reset')
  },
  async setMeta ({ commit }, payload) {
    commit('setMeta', payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true
}
